var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 10C19.6 15.302 15.302 19.6 10 19.6C4.69809 19.6 0.400024 15.302 0.400024 10C0.400024 4.69809 4.69809 0.400024 10 0.400024C15.302 0.400024 19.6 4.69809 19.6 10ZM11.2 5.20002C11.2 5.86277 10.6628 6.40002 10 6.40002C9.33728 6.40002 8.80002 5.86277 8.80002 5.20002C8.80002 4.53728 9.33728 4.00002 10 4.00002C10.6628 4.00002 11.2 4.53728 11.2 5.20002ZM8.80002 8.80002C8.13728 8.80002 7.60002 9.33728 7.60002 10C7.60002 10.6628 8.13728 11.2 8.80002 11.2V14.8C8.80002 15.4628 9.33728 16 10 16H11.2C11.8628 16 12.4 15.4628 12.4 14.8C12.4 14.1373 11.8628 13.6 11.2 13.6V10C11.2 9.33728 10.6628 8.80002 10 8.80002H8.80002Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.e9f85ef45dcb2d4570cfeefb06b8e9bb.svg";
export { ForwardRef as ReactComponent };